<template>
    <footer id="sobre" class="page-footer teal">
        <div class="">
            <div class="row">
                <h5 class="white-text left">More about me...</h5>
                <br><br>
                <p class="grey-text text-lighten-4">
                    {{ info }}            
                </p>
            </div>
        </div>
        
        <a href="#topo" class="scrollSuave">
            <div class="footer-copyright">
                <div class="container">
                    <span class="grey-text text-lighten-4 " >&copy; {{ yearUpdate }} - juscilan.com   </span>
                    <span class="grey-text text-lighten-4 " >Version {{ version }} </span>
                </div>
            </div>
        </a>
    </footer>
</template>

<script>

import {scroll} from './common/jm-scroll'

export default {
  name: 'footer-component',
  data () {
    return {
      info: `
      Hi there, I'm Juscilan, and I reside in the vibrant city of São Paulo, Brazil, along with my beloved wife and daughter. 
      With a robust career spanning over two decades, I have embraced the role of a seasoned developer. Throughout my journey, 
      I've had the privilege of contributing my expertise to a multitude of esteemed companies within my homeland. 
      Notable among them are Carrefour, Alpargatas, Bematech, Leroy Merlin, PRODESP, Accenture, Santander, Vortigo, Postclick Inc. and Xogito Inc.

      Over the past eleven years, my focus has been dedicated to crafting and sustaining software solutions for these valued clients. 
      If you're interested in delving further into my professional background, I'd be delighted to provide additional details. 
      Feel free to reach out to me via email at juscilan@gmail.com or give me a call at +55 11981671595. 
      Looking forward to connecting!
      `,
      yearUpdate: 0,
      version: '7.0.0'
    }
  },
  mounted () {
    scroll('scrollSuave')
    this.yearUpdate = new Date().getFullYear()
  }
}
</script>

<style scoped>

.white-text, .text-lighten-4, .text-lighten-4{
    margin-left: 5%;
    margin-right: 5%;
}

</style>



// WEBPACK FOOTER //
// jm-i-footer.vue?5603faea